import React, {createRef, useState, useContext} from 'react';
import {useQueryClient} from "react-query";
import {useAuth0} from "@auth0/auth0-react";
import __ from "lodash";
import moment from "moment";
import MaterialTable from "@material-table/core";
import { defaultComponents, MaterialTableBody, MaterialTableBodyRow } from '../../../controls/Material-Table-Components';
import SystemContext from "../../../SystemContext";
import {ColumnWidth, ValidatorColumn} from "../../../blocks/ColumnHelper";
import {useFlightMessages} from "../../../services/flights";
import { useTheme } from '@material-ui/core';

const FlightMessagesList = (_props) => {
  const SystemData = useContext(SystemContext);
  const theme = useTheme();
  const {isAuthenticated} = useAuth0();
  const eventBus = SystemData.eventBus;

  const props = {
    ..._props
  }
  const {classes, extraKeys, messageFilter} = props;

  const [state] = useState({
    canEdit: props.canEdit,
    activeRow: null
  });

  const tableRef = createRef({state: {lastEditingRow: false}});
  let selectedRow = -1;

  if (eventBus) {
    eventBus.bind('DeadLoad.AddFunction', ()=> {
      if (tableRef  && tableRef.current) {
        tableRef.current.dataManager.changeRowEditing();
        tableRef.current.setState({
          ...tableRef.current.dataManager.getRenderState(),
          showAddRow: !tableRef.current.state.showAddRow,
        });
      }
    });
  }

  const handleRowClick = (event, rowData) => {
    if (rowData.tableData.id >= 0) {
      selectedRow = rowData.tableData.id;
      if (eventBus) {
        if (__.has(rowData, "attachments") && JSON.stringify(rowData.attachments).length > 2) {
          rowData ["hasAttachments"] = true;
        }
        eventBus.trigger('FlightMessageContent.rowSelected', rowData.messageContent ? [{messageContent: rowData.messageContent}] : []);
      }
    }
  }


  const queryClient = useQueryClient();
  const messages = useFlightMessages({queryClient, extraKeys});

  const getColumns = (props) => {
    const baseColumn = {
      cellStyle: { padding: "8px 2px" },
      headerStyle: { padding: "8px 2px" },
      editable: state.canEdit?"always":"never",
      emptyValue: "",
      initialEditValue: "",
      sorting: false
    };
    const defaultEditProps = {
      style:{fontSize: "0.875rem"}
    };


    return [
      {
        ...baseColumn,
        ...ColumnWidth(80,[5,2],undefined,undefined,undefined,undefined,false),
        title: "Message",
        field: "uwsSource",
      },
      {
        ...baseColumn,
        ...ColumnWidth(115,2,undefined,undefined,undefined,undefined,false),
        title: "Received",
        field: "uwsTime",
        render: rowData => {
          if (rowData?.tableData?.isScrolling) return (
            <span>{moment(rowData.uwsTime).format("DD/MM/YYYY HH:mm")}</span>
          );
          return (<span>{moment(rowData.uwsTime).format("DD/MM/YYYY HH:mm")}</span>)
        }
      },
    ];
  };


  const bodyRef = createRef();

  return (isAuthenticated &&
        <div className={classes.TripLegEditor} style={{width: "100%", overflow: "scroll", maxHeight: 700}}>
          <MaterialTable
            tableRef={tableRef}
            data={typeof messageFilter === "function"?messageFilter(messages.data):messages.data}
            style={{
              backgroundColor: "#fdfdfd",
              boxShadow: "none",
              border: "2px solid #aaaaaa",
              borderRadius: 0,
            }}
            onRowClick={handleRowClick}
            options={{
              highlightRowStyle: {backgroundColor: "#F69259"},
              actionsColumnIndex: -1,
              search: false,
              cellStyle: {
                padding: "8px 2px",
              },
              headerStyle: {
                backgroundColor: theme.palette.childTableHeader.backgroundColor,
                color: theme.palette.childTableHeader.textColor,
                padding: "2px",
              },
              toolbarButtonAlignment: "right",
              detailPanelType: "single",
              showTitle: false,
              toolbar: false,
              padding: 'dense',
              paging: false,
              filtering: false,
              draggable: false,
              grouping: false
            }}
            components={{
              ...defaultComponents,
              Body: (props) => (
                <MaterialTableBody
                  {...props}
                  ref={bodyRef}
                  rowHeight={46}
                  overscanRowCount={10}
                  addVirtualScrolling={true}
                  bodyHeight={600}
                  headerHeight={46}
                />
              ),
              Row: (props) => (
                <MaterialTableBodyRow
                  {...props}
                />
              ),
            }}
            title="Dead Load Statement"
            columns={getColumns({...props, canEdit: state.canEdit})}
            editable={{
              isEditable: false,
              isDeletable: false,
              onRowAdd: undefined,
              onRowUpdate: undefined,
              onRowDelete: undefined,
            }}
        />
      </div>
  );
}

export default FlightMessagesList;
